import { Pipe, PipeTransform } from '@angular/core';

import { getWarnLevel } from '../constants/constants';
import { WarnParameter } from '../enums/warn-parameter.enum';

@Pipe({ name: 'getWarnLevel', standalone: true })
export class GetWarnLevelPipe implements PipeTransform {
  transform(
    warnParameter: WarnParameter | string,
    thresholdsToEdit: any
  ): number {
    return getWarnLevel(warnParameter, thresholdsToEdit);
  }
}
